import { useEffect } from "react";
import { useErrorBoundary } from "react-error-boundary";

interface ErrorTriggeredProps {
  error?: any;
  children: React.ReactNode;
}

const ErrorTriggered = ({ error, children }: ErrorTriggeredProps) => {
  const { showBoundary } = useErrorBoundary();

  useEffect(() => {
    if (error) {
      showBoundary(new Error(error?.message || "Unknown Error"));
    }
  }, [error, showBoundary]);

  return <>{children}</>;
};

export default ErrorTriggered;
